import { apiService } from './api';
import type { DashboardData, UserActivity, TrackActivityRequest, PagedResult } from '../types/dashboard';

export const dashboardService = {
  /**
   * Get personalized dashboard data for the authenticated user
   */
  async getDashboardData(userId?: string): Promise<DashboardData> {
    const url = userId ? `/api/dashboard?userId=${userId}` : '/api/dashboard';
    const response = await apiService.get(url);
    return response as DashboardData;
  },

  /**
   * Track user activity
   */
  async trackActivity(request: TrackActivityRequest): Promise<void> {
    await apiService.post('/api/dashboard/activity', request);
  },

  /**
   * Get user activities
   */
  async getUserActivities(limit: number = 50): Promise<UserActivity[]> {
    const response = await apiService.get(`/api/dashboard/activities?limit=${limit}`);
    return response as UserActivity[];
  },

  /**
   * Get user activities with pagination
   */
  async getUserActivitiesPaged(pageNumber: number = 1, pageSize: number = 20): Promise<PagedResult<UserActivity>> {
    const response = await apiService.get(`/api/dashboard/activities/paged?pageNumber=${pageNumber}&pageSize=${pageSize}`);
    return response as PagedResult<UserActivity>;
  }
};
